<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab" @tab-click="tabHandleClick">
      <el-tab-pane label="素材需求" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>产品名称：</label>
                <el-select
                  v-model="searchForm.product_id"
                  :size="size"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="getProjectLists"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.id"
                    :label="item.product_name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <!-- <div class="k-close-icon">
                                    <i class="el-icon-close" @click="resetStatus"></i>
                </div>-->
              </div>
            </div>
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>需求等级：</label>
                <el-select
                  v-model="searchForm.need_status"
                  placeholder="请选择需求等级"
                  :size="size"
                  filterable
                  clearable
                  reserve-keyword
                >
                  <el-option
                    v-for="item in needOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="k-filter-option">
              <div class="k-select-area">
                <label>上传类型：</label>
                <el-select
                  v-model="searchForm.order_type"
                  placeholder="请选择结单类型"
                  :size="size"
                  clearable
                  reserve-keyword
                >
                  <el-option
                    v-for="item in nameOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>-->
            <el-button :size="size" type="primary" icon="el-icon-search" @click="handleSearch(1)">搜索</el-button>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar">
                <div>
                  <el-button
                    :size="size"
                    type="primary"
                    icon="el-icon-user"
                    @click="addTagsOpen"
                  >新增需求</el-button>
                </div>
              </div>
              <div class="k-table-con">
                <el-table :loading="loading" :data="needData.data" border style="width: 100%">
                  <el-table-column fixed="left" prop="id" label="ID" width="80"></el-table-column>
                  <el-table-column prop="media_name" label="所属媒体" min-width="100"></el-table-column>
                  <el-table-column prop="industry_name" label="所属行业" min-width="100"></el-table-column>
                  <el-table-column prop="company_name" label="所属公司" min-width="100"></el-table-column>
                  <el-table-column prop="product_name" label="产品名称" min-width="100"></el-table-column>
                  <el-table-column prop="need_status" label="需求等级" width="100">
                    <template slot-scope="scope">
                      <el-tag size="mini" v-if="scope.row.need_status == 2">第二梯队</el-tag>
                      <el-tag size="mini" v-if="scope.row.need_status == 3" type="success">第三梯队</el-tag>
                      <el-tag size="mini" v-if="scope.row.need_status == 1" type="danger">第一梯队</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="order_type" label="结单类型" width="100">
                    <template slot-scope="scope">
                      <el-tag size="mini" v-if="scope.row.order_type == 2">上传结单</el-tag>
                      <el-tag size="mini" v-else-if="scope.row.order_type == 1">手动结单</el-tag>
                      <el-tag size="mini" v-else>暂无</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="progress" label="脚本进度" width="100">
                    <template slot-scope="scope">
                      <el-progress
                        :text-inside="true"
                        :stroke-width="15"
                        :percentage="scope.row.progress"
                      ></el-progress>
                    </template>
                  </el-table-column>
                  <el-table-column prop="source_progress" label="素材进度" width="110">
                    <template slot-scope="scope">
                      <el-progress
                        :text-inside="true"
                        :stroke-width="15"
                        :percentage="scope.row.source_progress"
                      ></el-progress>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="hand_progress" label="手动结单率" width="100"></el-table-column>
                  <el-table-column prop="upload_progress" label="上传结单率" width="100"></el-table-column>-->
                  <el-table-column prop="admin_id" label="负责人" width="100"></el-table-column>
                  <el-table-column prop="manager_id" label="负责人组长" width="100"></el-table-column>
                  <el-table-column prop="photo_number" label="实拍数量" width="100"></el-table-column>
                  <el-table-column prop="cutting_number" label="剪辑数量" width="100"></el-table-column>
                  <el-table-column prop="editting_number" label="改单数量" width="100"></el-table-column>
                  <el-table-column prop="total_number" label="总计数量" width="100"></el-table-column>
                  <el-table-column prop="create_time" label="创建时间" min-width="180"></el-table-column>
                  <el-table-column label="操作" fixed="right" min-width="180">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        :size="size"
                        class="c-danger"
                        @click="editNeedOpen(scope.row.id)"
                      >修改</el-button>
                      <el-button type="text" :size="size" @click="acceptOrderOpen(scope.row.id)">接单</el-button>
                      <el-button
                        type="text"
                        :size="size"
                        style="color:red"
                        @click="actionOrderOpen(scope.row)"
                      >结单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="needData.page | number"
                  :page-size="needData.pageSize | number"
                  layout="total, prev, pager, next, jumper"
                  :total="needData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="素材列表" name="second">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>产品名称：</label>
                <el-select
                  v-model="sourceForm.product_id"
                  :size="size"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="getProjectSourceLists"
                >
                  <el-option
                    v-for="item in projectsSource"
                    :key="item.id"
                    :label="item.product_name+':'+item.id"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <!-- <div class="k-close-icon">
                                    <i class="el-icon-close" @click="resetStatus"></i>
                </div>-->
              </div>
            </div>
            <el-button :size="size" type="primary" icon="el-icon-search" @click="getDirTree(1)">搜索</el-button>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-con">
                <el-table
                  :loading="loading"
                  row-key="path"
                  :data="projectLists.data"
                  border
                  style="width: 100%"
                >
                  <el-table-column fixed="left" prop="step" label="层级" min-width="100"></el-table-column>
                  <el-table-column prop="id" label="类型" width="80">
                    <template slot-scope="scope">
                      <template v-if="scope.row.type == 'directory'">
                        <i class="el-icon-folder-opened" style="font-size:20px;font-weight:500"></i>_目录
                      </template>
                      <template v-if="scope.row.type == 'image'">
                        <i class="el-icon-picture-outline" style="font-size:20px;font-weight:500"></i>_图片
                      </template>
                      <template v-if="scope.row.type == 'video'">
                        <i class="el-icon-video-camera" style="font-size:20px;font-weight:500"></i>_视频
                      </template>
                      <template v-if="scope.row.type == 'file'">
                        <i class="el-icon-document" style="font-size:20px;font-weight:500"></i>_文件
                      </template>
                      <template v-if="scope.row.type == 'None'">
                        <i class="el-icon-warning-outline" style="font-size:20px;font-weight:500"></i>_未知
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="目录/文件名称" min-width="100"></el-table-column>
                  <el-table-column prop="path" label="相关路径" min-width="180"></el-table-column>
                  <el-table-column label="预览" min-width="80">
                    <template slot-scope="scope">
                      <el-link
                        v-if="scope.row.type != 'directory' && (scope.row.type == 'file' || scope.row.type == 'None')"
                        style="font-size:12px"
                        type="primary"
                        @click="download(env.VUE_APP_BASE_SOURCE + scope.row.path)"
                      >预览</el-link>
                      <el-link
                        style="font-size:12px"
                        type="primary"
                        v-if="scope.row.type != 'directory' && (scope.row.type == 'image' || scope.row.type == 'video')"
                        @click="showSource(env.VUE_APP_BASE_SOURCE + scope.row.path,scope.row.name,scope.row.type)"
                      >预览</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChangePro"
                  :current-page="projectLists.page | number"
                  :page-size="projectLists.pageSize | number"
                  layout="total, prev, pager, next, jumper"
                  :total="projectLists.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 结单窗口 -->
    <el-dialog
      @close="closeDialog(2)"
      title="结单设定"
      :visible.sync="dialogFormActionVisible"
      width="40%"
    >
      <el-form
        v-if="order_type == 1"
        label-position="top"
        ref="actionOrderForm"
        :model="actionOrderForm"
        :rules="rules.actionOrderForm"
        :size="size"
      >
        <el-form-item label="我的职业:" prop="role">
          <el-select
            v-model="actionOrderForm.role"
            placeholder="请选择职业"
            @change="getActionOrderInfo"
          >
            <el-option
              v-for="item in rolesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="actionOrderForm.role">
          <el-form-item label="实拍单数:" prop="photo_number">
            <el-input-number
              v-model="actionOrderForm.photo_number"
              :min="0"
              :max="actionOrderForm.otherInfo.p_number"
              label="数量"
            ></el-input-number>
            <el-link
              style="margin-left:20px"
              type="primary"
              :underline="false"
            >可结：{{actionOrderForm.otherInfo.p_number}}单</el-link>
          </el-form-item>
          <el-form-item label="剪辑单数:" prop="cutting_number">
            <el-input-number
              v-model="actionOrderForm.cutting_number"
              :min="0"
              :max="actionOrderForm.otherInfo.c_number"
              label="数量"
            ></el-input-number>
            <el-link
              style="margin-left:20px"
              type="primary"
              :underline="false"
            >可结：{{actionOrderForm.otherInfo.c_number}}单</el-link>
          </el-form-item>
          <el-form-item label="改单单数:" prop="editting_number">
            <el-input-number
              v-model="actionOrderForm.editting_number"
              :min="0"
              :max="actionOrderForm.otherInfo.e_number"
              label="数量"
            ></el-input-number>
            <el-link
              style="margin-left:20px"
              type="primary"
              :underline="false"
            >可结：{{actionOrderForm.otherInfo.e_number}}单</el-link>
          </el-form-item>
        </template>
      </el-form>

      <el-form
        v-if="order_type == 2"
        label-position="top"
        ref="uploadOrderForm"
        :model="uploadOrderForm"
        :rules="rules.uploadOrderForm"
        :size="size"
      >
        <el-form-item label="我的职业:" prop="role">
          <el-select
            v-model="uploadOrderForm.role"
            placeholder="请选择职业"
            @change="getActionOrderInfo"
          >
            <el-option
              v-for="item in rolesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="uploadOrderForm.role">
          <el-form-item label="实拍上传:">
            <el-upload
              ref="upload_photo"
              :disabled="uploadOrderForm.otherInfo.p_number == 0"
              :limit="uploadOrderForm.otherInfo.p_number"
              action
              multiple
              :http-request="(file)=>{return imggreySuccess(file ,'p_files')}"
              :file-list="uploadOrderForm.p_list"
              :auto-upload="false"
              :on-exceed="limitMessage"
            >
              <el-button slot="trigger" :size="size" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">可结：{{uploadOrderForm.otherInfo.p_number}}单</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="剪辑上传:">
            <el-upload
              ref="upload_cut"
              action
              multiple
              :disabled="uploadOrderForm.otherInfo.c_number == 0"
              :limit="uploadOrderForm.otherInfo.c_number"
              :http-request="(file)=>{return imggreySuccess(file ,'c_files')}"
              :file-list="uploadOrderForm.c_list"
              :auto-upload="false"
              :on-exceed="limitMessage"
            >
              <el-button slot="trigger" :size="size" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">可结：{{uploadOrderForm.otherInfo.c_number}}单</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="改单上传:">
            <el-upload
              ref="upload_edit"
              action
              multiple
              :disabled="uploadOrderForm.otherInfo.e_number == 0"
              :limit="uploadOrderForm.otherInfo.e_number"
              :http-request="(file)=>{return imggreySuccess(file ,'e_files')}"
              :file-list="uploadOrderForm.e_list"
              :auto-upload="false"
              :on-exceed="limitMessage"
            >
              <el-button slot="trigger" :size="size" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">可结：{{uploadOrderForm.otherInfo.e_number}}单</div>
            </el-upload>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-popconfirm
          v-if="order_type == 2"
          confirm-button-text="是的"
          cancel-button-text="不结了"
          icon="el-icon-info"
          icon-color="red"
          title="确定结单吗？"
          @confirm="submitUpload"
        >
          <el-button slot="reference" :size="size" type="primary">结单</el-button>
        </el-popconfirm>
        <el-popconfirm
          v-if="order_type == 1"
          confirm-button-text="是的"
          cancel-button-text="不结了"
          icon="el-icon-info"
          icon-color="red"
          title="确定结单吗？"
          @confirm="acceprOrder(2)"
        >
          <el-button slot="reference" :size="size" type="primary">结单</el-button>
        </el-popconfirm>
        <el-button style="margin-left:15px" :size="size" @click="dialogFormActionVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 接单弹窗 -->
    <el-dialog @close="closeDialog(1)" title="接单设定" :visible.sync="dialogFormVisible" width="40%">
      <el-form
        ref="orderForm"
        label-position="top"
        :model="orderForm"
        :rules="rules.orderForm"
        :size="size"
      >
        <el-form-item label="我的职业:" prop="role">
          <el-select v-model="orderForm.role" placeholder="请选择职业" @change="getOrderInfo">
            <el-option
              v-for="item in rolesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="orderForm.role">
          <el-form-item label="实拍单数:" prop="photo_number">
            <el-input-number
              v-model="orderForm.photo_number"
              :min="0"
              :max="orderForm.otherInfo.p_number"
              label="数量"
            ></el-input-number>
            <el-popover placement="top-start" title="历史详情" width="350" trigger="click">
              <div>
                <el-timeline v-if="orderForm.otherInfo.p_list.length > 0">
                  <el-timeline-item
                    v-for="(info,key) in orderForm.otherInfo.p_list"
                    :key="key"
                    :timestamp="returnTime(info.create_time)"
                    placement="top"
                  >
                    <el-card>
                      <h4>数量：{{ info.photo_number }} 单</h4>
                      <p>{{info.nick_name}} 接单于 {{ info.create_time }}</p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
                <template v-else>暂无记录</template>
              </div>
              <el-link
                slot="reference"
                style="margin-left:20px"
                type="primary"
                :underline="false"
              >剩余可接：{{orderForm.otherInfo.p_number}}单</el-link>
            </el-popover>
          </el-form-item>
          <el-form-item label="剪辑单数:" prop="cutting_number">
            <el-input-number
              v-model="orderForm.cutting_number"
              :min="0"
              :max="orderForm.otherInfo.c_number"
              label="数量"
            ></el-input-number>
            <el-popover placement="top-start" title="历史详情" width="350" trigger="click">
              <div>
                <el-timeline v-if="orderForm.otherInfo.c_list.length > 0">
                  <el-timeline-item
                    v-for="(info,key) in orderForm.otherInfo.c_list"
                    :key="key"
                    :timestamp="returnTime(info.create_time)"
                    placement="top"
                  >
                    <el-card>
                      <h4>数量：{{ info.cutting_number }} 单</h4>
                      <p>{{info.nick_name}} 接单于 {{ info.create_time }}</p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
                <template v-else>暂无记录</template>
              </div>
              <el-link
                slot="reference"
                style="margin-left:20px"
                type="primary"
                :underline="false"
              >剩余可接：{{orderForm.otherInfo.c_number}}单</el-link>
            </el-popover>
          </el-form-item>
          <el-form-item label="改单单数:" prop="editting_number">
            <el-input-number
              v-model="orderForm.editting_number"
              :min="0"
              :max="orderForm.otherInfo.e_number"
              label="数量"
            ></el-input-number>
            <el-popover placement="top-start" title="历史详情" width="350" trigger="click">
              <div>
                <el-timeline v-if="orderForm.otherInfo.e_list.length > 0">
                  <el-timeline-item
                    v-for="(info,key) in orderForm.otherInfo.e_list"
                    :key="key"
                    :timestamp="returnTime(info.create_time)"
                    placement="top"
                  >
                    <el-card>
                      <h4>数量：{{ info.editting_number }} 单</h4>
                      <p>{{info.nick_name}} 接单于 {{ info.create_time }}</p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
                <template v-else>暂无记录</template>
              </div>
              <el-link
                slot="reference"
                style="margin-left:20px"
                type="primary"
                :underline="false"
              >剩余可接：{{orderForm.otherInfo.e_number}}单</el-link>
            </el-popover>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-popconfirm
          confirm-button-text="是的"
          cancel-button-text="不接了"
          icon="el-icon-info"
          icon-color="red"
          title="确定接单吗？"
          @confirm="acceprOrder(1)"
        >
          <el-button slot="reference" :size="size" type="primary">接单</el-button>
        </el-popconfirm>
        <el-button style="margin-left:15px" :size="size" @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 打开新增标签包 -->
    <el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" size="50%">
      <el-form
        :model="addForm"
        ref="addForm"
        :rules="rules.addForm"
        label-width="110px"
        :size="size"
      >
        <div class="drawer-header">
          <div class="header-title">
            <span v-if="tagType == 'add'">新增需求</span>
            <span v-if="tagType == 'edit'">修改需求</span>
            <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="所属媒体:" prop="media_name">
            <el-input placeholder="请输入所属媒体名称" v-model="addForm.media_name"></el-input>
          </el-form-item>
          <el-form-item label="所属行业:" prop="industry_name">
            <el-input placeholder="请输入所属行业名称" v-model="addForm.industry_name"></el-input>
          </el-form-item>
          <el-form-item label="所属公司:" prop="company_name">
            <el-input placeholder="请输入所属公司名称" v-model="addForm.company_name"></el-input>
          </el-form-item>
          <el-form-item label="产品名称:" prop="product_name">
            <el-input placeholder="请输入产品名称" v-model="addForm.product_name"></el-input>
          </el-form-item>
          <el-form-item label="需求等级:" prop="need_status">
            <el-select v-model="addForm.need_status" placeholder="请选择等级">
              <el-option
                v-for="item in needOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="负责人组长:" prop="manager_id">
            <el-select
              style="width: 100%"
              v-model="addForm.manager_id"
              filterable
              placeholder="请输入关键词"
            >
              <el-option
                v-for="item in managerOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="实拍单数:" prop="photo_number">
            <el-input-number v-model="addForm.photo_number" :min="0" label="数量"></el-input-number>
          </el-form-item>
          <el-form-item label="剪辑单数:" prop="cutting_number">
            <el-input-number v-model="addForm.cutting_number" :min="0" label="数量"></el-input-number>
          </el-form-item>
          <el-form-item label="改单单数:" prop="editting_number">
            <el-input-number v-model="addForm.editting_number" :min="0" label="数量"></el-input-number>
          </el-form-item>
          <el-form-item
            label="视频总计:"
          >{{ addForm.photo_number + addForm.cutting_number + addForm.editting_number}}</el-form-item>
          <!-- <el-form-item label="结单类型" prop="order_type">
            <el-select
              style="width: 100%"
              v-model="addForm.order_type"
              filterable
              placeholder="请选择类型"
            >
              <el-option
                v-for="item in orderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="备注:">
            <el-input type="textarea" :rows="5" placeholder="请输入备注信息" v-model="addForm.remark"></el-input>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" v-if="tagType == 'add'" @click="addNeeds" :size="size">提交</el-button>
          <el-button type="primary" v-if="tagType == 'edit'" @click="editNeeds" :size="size">修改</el-button>
          <el-button :size="size" @click="addFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
    <el-drawer
      custom-class="k-drawer"
      :visible.sync="eidtFormVisiable"
      direction="rtl"
      destroy-on-close
      size="50%"
    >
      <div class="detail_dialog">
        <div class="detail_dialog_con">
          <div class="detail_header">
            <b>文件名：</b>
            <span class="name">{{showInfo.name}}</span>
            <i class="el-icon-close detail_dialog_close" @click="eidtFormVisiable = false"></i>
          </div>
          <div class="detail_main" style="height:calc(100vh - 66px)">
            <div class="videoimg_box" v-if="showInfo.type == 'video'">
              <video
                :src="showInfo.path"
                controls="controls"
                preload="none"
                controlslist
                style="width: auto; height: 100%;"
              >
                <a class="btn_play"></a>
              </video>
            </div>
            <div class="videoimg_box" v-if="showInfo.type == 'image'">
              <img :src="showInfo.path" :alt="showInfo.name" />
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      eidtFormVisiable: false,
      addFormVisiable: false,
      dialogFormVisible: false,
      dialogFormActionVisible: false,
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      loading: false,
      size: 'mini',
      order_type: '',
      showInfo: {
        path: '',
        name: '',
        type: ''
      },
      nameOptions: [
        {
          label: '手动结单',
          value: '1'
        },
        {
          label: '上传结单',
          value: '2'
        }
      ],
      projects: [],
      projectsSource: [],
      rolesOptions: [
        {
          label: '编导',
          value: '1'
        },
        {
          label: '剪辑',
          value: '2'
        }
      ],
      orderOptions: [
        {
          label: '手动结单',
          value: '1'
        },
        {
          label: '上传结单',
          value: '2'
        }
      ],
      needOptions: [
        {
          label: '第一梯队',
          value: 1
        },
        {
          label: '第二梯队',
          value: 2
        },
        {
          label: '第三梯队',
          value: 3
        }
      ],
      adminOptions: [],
      managerOptions: [],
      sourceForm: {
        product_id: ''
      },
      searchForm: {
        product_id: '',
        order_type: '',
        need_status: ''
      },
      uploadOrderForm: {
        id: '',
        role: '',
        p_list: [],
        p_files: [],
        c_list: [],
        c_files: [],
        e_list: [],
        e_files: [],
        otherInfo: {
          p_number: 0,
          c_number: 0,
          e_number: 0
        }
      },
      actionOrderForm: {
        id: '',
        role: '',
        photo_number: 0,
        cutting_number: 0,
        editting_number: 0,
        otherInfo: {
          p_number: 0,
          c_number: 0,
          e_number: 0
        }
      },
      orderForm: {
        id: '',
        role: '',
        photo_number: 0,
        cutting_number: 0,
        editting_number: 0,
        otherInfo: {
          p_number: 0,
          c_number: 0,
          e_number: 0,
          p_list: [],
          c_list: [],
          e_list: []
        }
      },
      addForm: {
        id: '',
        media_name: '',
        industry_name: '',
        company_name: '',
        product_name: '',
        need_status: '',
        admin_id: '',
        manager_id: '',
        photo_number: 0,
        cutting_number: 0,
        editting_number: 0,
        total_number: 0,
        // order_type: '1',
        remark: ''
      },
      needData: {
        total: 0,
        pagesize: 15,
        page: 1,
        data: []
      },
      projectLists: {
        total: '',
        page: '1',
        pagesize: 10,
        data: []
      },
      tagType: 'add',
      rules: {
        orderForm: {
          role: [
            {
              required: true,
              message: '请选择职业',
              trigger: ['change']
            }
          ],
          photo_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.orderForm.photo_number == 0 &&
                  this.orderForm.editting_number == 0 &&
                  this.orderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ],
          cutting_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.orderForm.photo_number == 0 &&
                  this.orderForm.editting_number == 0 &&
                  this.orderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ],
          editting_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.orderForm.photo_number == 0 &&
                  this.orderForm.editting_number == 0 &&
                  this.orderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ]
        },
        uploadOrderForm: {
          role: [
            {
              required: true,
              message: '请选择职业',
              trigger: ['change']
            }
          ],
          photo_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.uploadOrderForm.photo_number == 0 &&
                  this.uploadOrderForm.editting_number == 0 &&
                  this.uploadOrderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ],
          cutting_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.uploadOrderForm.photo_number == 0 &&
                  this.uploadOrderForm.editting_number == 0 &&
                  this.uploadOrderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ],
          editting_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.uploadOrderForm.photo_number == 0 &&
                  this.uploadOrderForm.editting_number == 0 &&
                  this.uploadOrderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ]
        },
        actionOrderForm: {
          role: [
            {
              required: true,
              message: '请选择职业',
              trigger: ['change']
            }
          ],
          photo_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.actionOrderForm.photo_number == 0 &&
                  this.actionOrderForm.editting_number == 0 &&
                  this.actionOrderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ],
          cutting_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.actionOrderForm.photo_number == 0 &&
                  this.actionOrderForm.editting_number == 0 &&
                  this.actionOrderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ],
          editting_number: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.actionOrderForm.photo_number == 0 &&
                  this.actionOrderForm.editting_number == 0 &&
                  this.actionOrderForm.cutting_number == 0
                ) {
                  return callback(
                    new Error('实拍单数|剪辑单数|改单单数至少一个不能为0')
                  )
                }
                callback()
              },
              trigger: ['change', 'blur']
            }
          ]
        },
        addForm: {
          media_name: [
            {
              required: true,
              message: '请输入媒体名称',
              trigger: ['change', 'blur']
            }
          ],
          industry_name: [
            {
              required: true,
              message: '请输入所属行业',
              trigger: ['change', 'blur']
            }
          ],
          company_name: [
            {
              required: true,
              message: '请输入公司名称',
              trigger: ['change', 'blur']
            }
          ],
          product_name: [
            {
              required: true,
              message: '请输入产品名称',
              trigger: ['change', 'blur']
            }
          ],
          need_status: [
            {
              required: true,
              message: '请选择需求等级',
              trigger: ['change']
            }
          ],
          admin_id: [
            {
              required: true,
              message: '请选择负责人',
              trigger: ['change']
            }
          ],
          manager_id: [
            {
              required: true,
              message: '请选择负责人组长',
              trigger: ['change']
            }
          ]
        }
      }
    }
  },
  computed: {
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  methods: {
    closeDialog: function(status) {
      var form =
        status == 1
          ? 'orderForm'
          : this.order_type == 1
          ? 'actionOrderForm'
          : 'uploadOrderForm'
      if (form == 'orderForm') {
        this.dialogFormVisible = false
        this[form] = {
          id: '',
          role: '',
          photo_number: 0,
          cutting_number: 0,
          editting_number: 0,
          otherInfo: {
            p_number: 0,
            c_number: 0,
            e_number: 0,
            p_list: [],
            c_list: [],
            e_list: []
          }
        }
      } else if (form == 'uploadOrderForm') {
        this.dialogFormActionVisible = false
        this[form] = {
          id: '',
          role: '',
          p_list: [],
          p_files: [],
          c_list: [],
          c_files: [],
          e_list: [],
          e_files: [],
          otherInfo: {
            p_number: 0,
            c_number: 0,
            e_number: 0
          }
        }
      } else if (form == 'actionOrderForm') {
        this.dialogFormActionVisible = false
        this[form] = {
          id: '',
          role: '',
          photo_number: 0,
          cutting_number: 0,
          editting_number: 0,
          otherInfo: {
            p_number: 0,
            c_number: 0,
            e_number: 0
          }
        }
      }
    },
    limitMessage: function(files, fileList) {
      this.$message({
        showClose: true,
        message: `本次选择了 ${files.length} 个文件,超出最大要求数量限制`,
        type: 'warning'
      })
    },
    download: function(path) {
      const url = path
      const newWindow = window.open(url)
      newWindow.document.body.focus()
    },
    showSource: function(path, name, type) {
      this.showInfo.path = path
      this.showInfo.name = name
      this.showInfo.type = type
      this.eidtFormVisiable = true
    },
    tabHandleClick: function(tab, event) {
      if (tab.name == 'first') {
        this.handleSearch(1)
      }
      if (tab.name == 'second') {
        this.getDirTree(1)
      }
    },
    handleCurrentChangePro: function(page) {
      this.getDirTree(page)
    },
    getProjectSourceLists: function(query) {
      this.$api.get(
        'need/getnames',
        { name: query },
        function(res) {
          this.projectsSource = res.data
        }.bind(this)
      )
    },
    getProjectLists: function(query) {
      this.$api.get(
        'need/getnames',
        { name: query },
        function(res) {
          this.projects = res.data
        }.bind(this)
      )
    },
    getDirTree: function(page) {
      this.$api.get(
        'need/getdirtree',
        {
          product_id: this.sourceForm.product_id,
          page: page ? page : this.projectLists.page,
          pagesize: this.projectLists.pagesize
        },
        function(res) {
          this.projectLists = res.data
        }.bind(this)
      )
    },
    handleCurrentChange: function(page) {
      this.handleSearch(page)
    },
    submitUpload: function() {
      this.uploadOrderForm.p_files = []
      this.$refs.upload_photo.submit()

      this.uploadOrderForm.c_files = []
      this.$refs.upload_cut.submit()

      this.uploadOrderForm.e_files = []
      this.$refs.upload_edit.submit()

      var postData = this.uploadOrderForm
      const formData = new FormData()
      // console.log(Object.keys(postData))
      formData.append('id', postData['id'])
      formData.append('role', postData['role'])
      // postData['ceshi'].forEach(item => {
      //   formData.append('ceshi', item)
      // })
      postData['p_files'].forEach(item => {
        formData.append('p_files', item)
      })
      postData['c_files'].forEach(item => {
        formData.append('c_files', item)
      })
      postData['e_files'].forEach(item => {
        formData.append('e_files', item)
      })

      this.$api.post(
        'need/submitorder',
        formData,
        function(res) {
          this.dialogFormActionVisible = false
          this.handleSearch(1)
        }.bind(this)
      )
    },
    imggreySuccess: function(files, field) {
      this.uploadOrderForm[field].push(files.file)
    },
    actionOrderOpen: function(row) {
      if (row.order_type == 1) {
        this.actionOrderForm.id = row.id
      } else {
        this.uploadOrderForm.id = row.id
      }
      this.order_type = row.order_type
      this.dialogFormActionVisible = true
    },
    returnTime(time_info) {
      var strs = time_info.split(' ')
      return strs[0]
    },
    acceprOrder: function(status) {
      var form =
        status == 1
          ? 'orderForm'
          : this.order_type == 1
          ? 'actionOrderForm'
          : 'uploadOrderForm'
      this.$refs[form].validate(
        function(valid) {
          if (valid) {
            var postData = { ...this[form] }
            delete postData['otherInfo']
            postData['status'] = status
            this.$api.post(
              'need/addorder',
              postData,
              function(res) {
                if (res.code == 0) {
                  this.$message({
                    showClose: true,
                    message: '成功',
                    type: 'success'
                  })
                  this.handleSearch(1)
                  if (form == 'orderForm') {
                    this.dialogFormVisible = false
                    this[form] = {
                      id: '',
                      role: '',
                      photo_number: 0,
                      cutting_number: 0,
                      editting_number: 0,
                      otherInfo: {
                        p_number: 0,
                        c_number: 0,
                        e_number: 0,
                        p_list: [],
                        c_list: [],
                        e_list: []
                      }
                    }
                  } else if (form == 'uploadOrderForm') {
                    this.dialogFormActionVisible = false
                    this[form] = {
                      id: '',
                      role: '',
                      p_list: [],
                      p_files: [],
                      c_list: [],
                      c_files: [],
                      e_list: [],
                      e_files: [],
                      otherInfo: {
                        p_number: 0,
                        c_number: 0,
                        e_number: 0
                      }
                    }
                  } else if (form == 'actionOrderForm') {
                    this.dialogFormActionVisible = false
                    this[form] = {
                      id: '',
                      role: '',
                      photo_number: 0,
                      cutting_number: 0,
                      editting_number: 0,
                      otherInfo: {
                        p_number: 0,
                        c_number: 0,
                        e_number: 0
                      }
                    }
                  }
                }
              }.bind(this)
            )
          }
        }.bind(this)
      )
    },
    getActionOrderInfo: function(role) {
      var id =
        this.order_type == 1 ? this.actionOrderForm.id : this.uploadOrderForm.id

      this.$api.get(
        'need/getactionorderinfo',
        { id: id, role: role },
        function(res) {
          if (res.code == 0) {
            if (this.order_type == 1) {
              this.actionOrderForm.otherInfo = res.data
            } else {
              this.uploadOrderForm.otherInfo = res.data
            }
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error'
            })
          }
        }.bind(this)
      )
    },
    getOrderInfo: function(role) {
      var id = this.orderForm.id
      this.$api.get(
        'need/getorderinfo',
        { id: id, role: role, status: 1 },
        function(res) {
          if (res.code == 0) {
            this.orderForm.otherInfo = res.data
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error'
            })
          }
        }.bind(this)
      )
    },
    acceptOrderOpen: function(id) {
      this.orderForm.id = id
      this.dialogFormVisible = true
      this.order_type = ''
    },
    editNeedOpen: function(id) {
      this.$api.get(
        'need/getneed',
        { id: id },
        function(res) {
          if (res.code == 0) {
            this.tagType = 'edit'
            this.addForm = res.data
            this.addFormVisiable = true
          }
        }.bind(this)
      )
    },
    editNeeds: function() {
      this.$refs['addForm'].validate(
        function(valid) {
          if (valid) {
            this.addForm.total_number =
              this.addForm.photo_number +
              this.addForm.cutting_number +
              this.addForm.editting_number
            this.$api.post(
              'need/editneed',
              this.addForm,
              function(res) {
                if (res.code == 0) {
                  this.addFormVisiable = false
                  this.$message({
                    showClose: true,
                    message: '修改需求成功',
                    type: 'success'
                  })
                  this.handleSearch(1)
                }
              }.bind(this)
            )
          }
        }.bind(this)
      )
    },
    getAdmins: function() {
      this.$api.get(
        'need/getAdmins',
        {},
        function(res) {
          if (res.code == 0) {
            this.managerOptions = res.data
          }
        }.bind(this)
      )
    },
    addNeeds: function() {
      this.$refs['addForm'].validate(
        function(valid) {
          if (valid) {
            this.addForm.total_number =
              this.addForm.photo_number +
              this.addForm.cutting_number +
              this.addForm.editting_number
            this.$api.post(
              'need/addneed',
              this.addForm,
              function(res) {
                if (res.code == 0) {
                  this.addFormVisiable = false
                  this.$message({
                    showClose: true,
                    message: '添加需求成功',
                    type: 'success'
                  })
                }
                this.handleSearch(1)
              }.bind(this)
            )
          }
        }.bind(this)
      )
    },
    addTagsOpen: function() {
      this.addForm = {
        media_name: '',
        industry_name: '',
        company_name: '',
        product_name: '',
        need_status: '',
        admin_id: '',
        manager_id: '',
        photo_number: 0,
        cutting_number: 0,
        editting_number: 0,
        total_number: 0,
        remark: ''
      }

      this.tagType = 'add'
      this.addFormVisiable = true
    },
    handleSearch: function(page, prop, order) {
      var param = {}
      this.loading = true
      param['product_id'] = this.searchForm.product_id
      param['need_status'] = this.searchForm.need_status
      param['order_type'] = this.searchForm.order_type
      param['page'] = page ? page : 1
      param['pagesize'] = this.needData.pageSize ? this.needData.pageSize : 15
      param['prop'] = prop ? prop : 'id'
      param['order'] = order ? order : 'desc'
      this.$api.get(
        'need/needList',
        param,
        function(res) {
          if (res.code == 0) {
            this.needData = res.data
          }
        }.bind(this)
      )
    }
  },
  computed: {
    env() {
      return process.env
    }
  },
  beforeRouteUpdate: function(to, from, next) {},
  mounted: function() {
    this.handleSearch(1)

    this.getAdmins()
  }
}
</script>